import React from 'react';
import { Card } from 'react-bootstrap';

import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';
import ComplementoPlataformasTecnologicasBaseResumen from './ComplementoPlataformasTecnologicasBaseResumen';
import ComplementoPlataformasTecnologicasServiciosResumen from './ComplementoPlataformasTecnologicasServiciosResumen';

const ComplementoPlataformasTecnologicasResumen = ({ data = {}, onEdit, onDelete }) => {
  const handleOnDelete = () => {
    onDelete('ServiciosPlataformasTecnologicas');
  };

  const handleOnEdit = () => {
    onEdit('ServiciosPlataformasTecnologicas', data);
  };

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          <div className="d-block mt-3 mb-2">Servicios Plataformas Tecnológicas, Versión {data.Version}</div>
        </Card.Subtitle>

        <ComplementoPlataformasTecnologicasBaseResumen data={data} />

        <ComplementoPlataformasTecnologicasServiciosResumen data={data} />

        <ComplementoSummaryActionButtons
          onEdit={handleOnEdit}
          onDelete={handleOnDelete}
        />
      </Card.Body>
    </Card>
  );
};

export default ComplementoPlataformasTecnologicasResumen;
